<!-- Простой Windy компонент для Weather таба -->
<template>
  <div>
    <div id="windy" class="windy-container" />
  </div>
</template>

<script>
export default {
  name: 'WindyWeatherMap',
  props: {
    height: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      windyInstance: null,
      windyAPI: null,
      originalLeafletVersion: null,
      originalLeafletScripts: [],
      originalLeafletLinks: []
    };
  },
  mounted() {
    this.initWindy();
  },
  beforeDestroy() {
    console.log('🔄 Уничтожение WindyWeatherMap, подготавливаем восстановление Leaflet');
    
    // if (this.windyInstance) {
    //   // Cleanup Windy карты
    //   this.windyInstance = null;
    // }
    
    // // НЕ удаляем window.L сразу - оставляем это для инициализации новой карты
    // this.cleanupWindyResources();
  },
  methods: {
    async initWindy() {
      try {
        // Ждем пока Leaflet 1.4 и Windy API загрузятся
        await this.loadDependencies();
        
        // Проверяем что всё загружено корректно
        // if (!window.L) {
        //   throw new Error('Leaflet не загружен');
        // }
        
        // if (!window.L.version || !window.L.version.startsWith('1.4')) {
        //   throw new Error(`Неправильная версия Leaflet: ${window.L.version}. Требуется 1.4.x`);
        // }
        
        // if (!window.windyInit) {
        //   throw new Error('Windy API не загружен');
        // }
        
        // console.log('🎯 Все зависимости загружены:', {
        //   leafletVersion: window.L.version,
        //   windyInit: !!window.windyInit
        // });
        
        // Инициализируем Windy
        const options = {
          key: 'GkCOxdl18eKoAa8j9ihfP4kqPCBmOmnK',
          verbose: true,
          lat: 50.4,
          lon: 14.3,
          zoom: 5,
        };

        window.windyInit(options, (windyAPI) => {
          this.windyAPI = windyAPI;
          this.windyInstance = windyAPI.map;
          console.log('🌪️ Windy Weather карта инициализирована!');
          
          // Добавляем тестовый маршрут
          this.addTestRoute();
          
          // Эмитим событие что карта готова
          // this.$emit('windy-ready', windyAPI);
        });
        
      } catch (error) {
        console.error('Ошибка инициализации Windy Weather карты:', error);
      }
    },
    
    async loadDependencies() {
      // Сохраняем оригинальную версию Leaflet и скрипты
      // if (window.L && window.L.version) {
      //   console.log('💾 Сохраняем текущий Leaflet:', window.L.version);
      //   this.originalLeafletVersion = window.L.version;
        
      //   // Сохраняем ссылки на текущие скрипты и CSS
      //   this.originalLeafletScripts = Array.from(document.querySelectorAll('script[src*="leaflet"]'));
      //   this.originalLeafletLinks = Array.from(document.querySelectorAll('link[href*="leaflet"]'));
      // }
      
      // Удаляем существующий Leaflet если он неправильной версии
      // if (window.L && window.L.version && !window.L.version.startsWith('1.4')) {
      //   console.log('🔄 Удаляем Leaflet', window.L.version, 'для загрузки 1.4.0');
      //   delete window.L;
        
      //   // Удаляем все существующие скрипты Leaflet
      //   const existingScripts = document.querySelectorAll('script[src*="leaflet"]');
      //   existingScripts.forEach(script => script.remove());
        
      //   // Удаляем существующие CSS Leaflet
      //   const existingLinks = document.querySelectorAll('link[href*="leaflet"]');
      //   existingLinks.forEach(link => link.remove());
      // }
      
      // Загружаем Leaflet JS 1.4.0
      // if (!window.L || !window.L.version || !window.L.version.startsWith('1.4')) {
        console.log('🌿 Загружаем Leaflet 1.4.0 для Windy');
        await this.loadScript('https://unpkg.com/leaflet@1.4.0/dist/leaflet.js');
        console.log('✅ Leaflet 1.4.0 загружен:', window.L.version);
      // }
      
      // Загружаем Windy API
      // if (!window.windyInit) {
        console.log('🌪️ Загружаем Windy API');
        await this.loadScript('https://api.windy.com/assets/map-forecast/libBoot.js');
        console.log('✅ Windy API загружен');
      // }
    },
    
    // loadCSS(href) {
    //   return new Promise((resolve, reject) => {
    //     const existingLink = document.querySelector(`link[href="${href}"]`);
    //     if (existingLink) {
    //       resolve();
    //       return;
    //     }
        
    //     const link = document.createElement('link');
    //     link.rel = 'stylesheet';
    //     link.type = 'text/css';
    //     link.href = href;
    //     link.onload = resolve;
    //     link.onerror = reject;
    //     document.head.appendChild(link);
    //   });
    // },
    
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) {
          resolve();
          return;
        }
        
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    
    addTestRoute() {
      if (!this.windyInstance || !window.L) {
        console.error('Карта или Leaflet не готовы для добавления маршрута');
        return;
      }
      
      console.log('🗺️ Добавляем тестовый маршрут на Windy карту');
      
      // Определяем точки маршрута (из Лондона в Париж, Амстердам, Берлин, Прагу)
      const routePoints = [
        { lat: 51.5074, lng: -0.1278, name: 'Лондон' },      // 1
        { lat: 48.8566, lng: 2.3522, name: 'Париж' },       // 2  
        { lat: 52.3676, lng: 4.9041, name: 'Амстердам' },   // 3
        { lat: 52.5200, lng: 13.4050, name: 'Берлин' },     // 4
        { lat: 50.0755, lng: 14.4378, name: 'Прага' }       // 5
      ];
      
      // Создаем массив координат для линии маршрута
      const routeCoordinates = routePoints.map(point => [point.lat, point.lng]);
      
      // Рисуем линию маршрута
      const routeLine = window.L.polyline(routeCoordinates, {
        color: '#ff4444',
        weight: 4,
        opacity: 0.8,
        dashArray: '10, 5'
      }).addTo(this.windyInstance);
      
      // Добавляем маркеры с номерами и тултипами для каждой точки
      routePoints.forEach((point, index) => {
        // Создаем кастомную иконку с номером
        const numberIcon = window.L.divIcon({
          className: 'route-marker',
          html: `<div class="route-marker-inner">${index + 1}</div>`,
          iconSize: [30, 30],
          iconAnchor: [15, 15]
        });
        
        // Добавляем маркер
        const marker = window.L.marker([point.lat, point.lng], {
          icon: numberIcon
        }).addTo(this.windyInstance);
        
        // Добавляем тултип с информацией
        marker.bindTooltip(`
          <div class="route-tooltip">
            <strong>Точка ${index + 1}</strong><br>
            ${point.name}<br>
            <small>${point.lat.toFixed(4)}, ${point.lng.toFixed(4)}</small>
          </div>
        `, {
          permanent: false,
          direction: 'top',
          offset: [0, -10]
        });
        
        // Добавляем popup при клике
        marker.bindPopup(`
          <div class="route-popup">
            <h4>🎯 Точка ${index + 1}</h4>
            <p><strong>${point.name}</strong></p>
            <p>Координаты: ${point.lat.toFixed(4)}, ${point.lng.toFixed(4)}</p>
            <p>Расстояние от начала: ${this.calculateDistance(routePoints[0], point).toFixed(1)} км</p>
          </div>
        `);
      });
      
      // Подгоняем карту под маршрут
      this.windyInstance.fitBounds(routeLine.getBounds(), { padding: [20, 20] });
      
      console.log('✅ Тестовый маршрут добавлен с', routePoints.length, 'точками');
    },
    
    calculateDistance(point1, point2) {
      // Простой расчет расстояния между точками (приблизительный)
      const R = 6371; // Радиус Земли в км
      const dLat = this.toRadians(point2.lat - point1.lat);
      const dLon = this.toRadians(point2.lng - point1.lng);
      const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.toRadians(point1.lat)) * Math.cos(this.toRadians(point2.lat)) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      return R * c;
    },
    
    toRadians(degrees) {
      return degrees * (Math.PI/180);
    },
    
    cleanupWindyResources() {
      try {
        console.log('🧹 Очищаем ресурсы Windy (оставляем Leaflet для плавного переключения)');
        
        // Удаляем только Windy API
        delete window.windyInit;
        
        // Удаляем только скрипты Windy API (НЕ трогаем Leaflet пока)
        const windyScripts = document.querySelectorAll('script[src*="windy.com"], script[src*="api.windy.com"]');
        windyScripts.forEach(script => {
          console.log('🗑️ Удаляем Windy скрипт:', script.src);
          script.remove();
        });
        
        // Помечаем что Leaflet 1.4.0 нужно будет заменить позже
        if (window.L && window.L.version && window.L.version.startsWith('1.4')) {
          window.L._needsReplacement = true;
          console.log('🏷️ Помечаем Leaflet 1.4.0 для замены на оригинальную версию');
        }
        
        console.log('✅ Ресурсы Windy очищены, Leaflet будет заменен при переинициализации');
        
        // Эмитим событие что Windy карта уничтожена
        this.$emit('windy-destroyed');
        
      } catch (error) {
        console.error('Ошибка при очистке ресурсов Windy:', error);
      }
    }
  }
};
</script>

<style scoped>

.windy-container {
  height: 600px;
}

/* Стили для маркеров маршрута */
:deep(.route-marker) {
  background: none !important;
  border: none !important;
}

:deep(.route-marker-inner) {
  background: #ff4444;
  color: white;
  border: 3px solid white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

/* Стили для тултипов */
:deep(.route-tooltip) {
  background: rgba(0,0,0,0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
}

/* Стили для попапов */
:deep(.route-popup) {
  min-width: 200px;
}

:deep(.route-popup h4) {
  margin: 0 0 10px 0;
  color: #ff4444;
}

:deep(.route-popup p) {
  margin: 5px 0;
  font-size: 13px;
}

/* Для обеспечения видимости контролов */
</style>